<template>
  <div class="music-wrapper">
    <div
      v-if="isMuted"
      class="mute-icon"
      :class="showMutedNotice && 'notice'"
      v-click="() => bus.emit(EVENT_KEY.REMOVE_MUTED)"
    >
      <div class="wrap">
        <SoundMute1FilledIcon />
        <span :style="{ opacity: showMutedNotice ? 1 : 0 }">取消静音</span>
      </div>
    </div>
    <!-- <img
      class="music"
      :src="item.music?.cover_thumb.url_list[0]"
      :style="style"
      v-click="
        () =>
          bus.emit(EVENT_KEY.NAV, {
            path: '/home/music',
            query: { id: item.aweme_id },
          })
      "
    /> -->
  </div>
</template>
<script setup lang="ts">
import { inject, onMounted, ref, computed } from "vue";
import bus, { EVENT_KEY } from "@/utils/bus";
import { useClick } from "@/utils/hooks/useClick";

const isPlaying = inject<boolean>("isPlaying");
const isMuted = inject("isMuted");
const item = inject<any>("item");
const vClick = useClick();
const showMutedNotice = ref(false);

const style = computed(() => {
  return { webkitAnimationPlayState: isPlaying.value ? "running" : "paused" };
});
onMounted(() => {
  bus.on(EVENT_KEY.HIDE_MUTED_NOTICE, () => {
    showMutedNotice.value = false;
  });
});
</script>

<style lang="less">
.music-wrapper {
  display: flex;
  justify-content: center;
  @w: 2.8125rem;
  width: @w;
  height: @w;
  position: relative;
  z-index: 99;

  .music {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: animations 5s linear forwards infinite;
    //animation-play-state:paused;
    //display: none;
  }

  @keyframes animations {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .mute-icon {
    .music;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    right: 0;
    background: white;
    animation: unset;
    color: black;
    transition: all 0.5s;
    overflow: hidden;

    .wrap {
      width: 6.25rem;
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.notice {
      border-radius: 3.125rem;
      width: 6.25rem;
    }

    svg {
      font-size: 1.375rem;
    }

    span {
      margin-left: 0.3125rem;
      font-size: 0.8125rem;
      word-break: keep-all;
      transition: all 0.5s;
    }
  }
}
</style>
